import http from './http-commons';
// import urlencode from 'urlencode';
class UserService {
    newAdmin(data) {
      return http.post('/api/admin', data);
    }
    adminLogin(data) {
      return http.post('/api/admin_auth/login', data);
    }

    changePassword(data) {
      return http.post('/api/auth/change_password', data);
    }
    
    requestPasswordReset(data){
      return http.post('/api/auth/request_password_reset', data)
    }

    resetPassword(data){
      return http.post('/api/auth/reset-password', data)
    }
    

  
  
    
    createUser(data) {
      return http.post('/api/admin/', data);
    }
    getUser(id) {
      return http.get(`/api/admin/${id}`);
    }
    getUsers() {
      return http.get('/api/admin/');
    }

    
    // getJobs(){
    //   return http.get('/jobs')
    // }
  
  }
  
  
  export default new UserService();







